import { render } from "./ExpandableCheckbox.vue?vue&type=template&id=b273c0f4"
import script from "./ExpandableCheckbox.vue?vue&type=script&lang=js"
export * from "./ExpandableCheckbox.vue?vue&type=script&lang=js"
script.render = render

export default script